/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-danger[_ngcontent-%COMP%]{background-color:#f56f6f;color:#fff}.mat-danger-text[_ngcontent-%COMP%]{color:#f56f6f}\n/*# sourceMappingURL=manage-package.component.css.map*/"];
export { styles as styles };
